var _path, _path2, _circle, _circle2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnavailable = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 512,
  height: 512,
  viewBox: "0 0 135.467 135.467",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "normal"
  },
  fill: "#d21e1e",
  stroke: "#d21e1e",
  strokeWidth: 1.489,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "markers stroke fill",
  d: "M8.481 122.697h116.196v.199H8.481z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "normal"
  },
  fill: "#d21e1e",
  stroke: "#d21e1e",
  strokeWidth: 1.302,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "markers stroke fill",
  d: "M17.355 125.622h62.456v.283H17.355z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "normal"
  },
  fill: "#d21e1e",
  stroke: "#d21e1e",
  strokeWidth: 1.158,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "markers stroke fill",
  d: "M84.838 125.559h32.32v.433h-32.32z"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.489 15.344v97.186h74.765V38.847H81.886V15.306zm50.527-.153l24.366 23.54z",
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 0.83
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.247 27.176V15.882l.128.126c.14.139 5.91 5.725 16.283 15.766 3.653 3.535 6.701 6.488 6.775 6.562l.134.134h-23.32z",
  fill: "#d21e1e",
  fillOpacity: 0.747,
  paintOrder: "markers stroke fill"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 59.752,
  cy: 50.916,
  r: 3.181,
  fill: "#d21e1e",
  paintOrder: "markers stroke fill"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 82.904,
  cy: 50.869,
  r: 3.181,
  fill: "#d21e1e",
  paintOrder: "markers stroke fill"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d21e1e",
  fillOpacity: 0.076,
  paintOrder: "stroke fill markers",
  d: "M34.925 19.069h10.583v90.188H34.925zm67.839 79.661v10.583H48.217V98.73z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M60.943 72.974c5.946-1.227 13.476-1.35 21.047.327-6.734-1.442-14.279-1.73-21.047-.327z",
  fill: "none",
  stroke: "#d21e1e",
  strokeWidth: 2.117
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.91 63.895v-48.09h49.52v23.48h24.386v72.701H31.91zm70.894 40.189V98.74H48.166v10.687h54.638zM45.57 64.159l-.038-45.118-5.306-.04-5.306-.04v90.316h10.688zm36.462 9.332c.095-.476.184-.966.2-1.09.02-.171-.395-.302-1.78-.558-3.589-.663-5.811-.855-9.934-.858-3.817-.003-5.053.088-8.328.612l-1.555.249.096.54c.168.935.387 1.67.498 1.666.06-.001.897-.133 1.863-.292 4.978-.822 11.3-.715 16.621.28 2.26.423 2.12.456 2.32-.55zM60.734 54.018c.373-.103.868-.432 1.3-.864.567-.568.728-.852.863-1.526.405-2.02-.846-3.74-2.823-3.883-1.894-.137-3.206.872-3.542 2.725-.12.663.22 1.972.634 2.437 1.008 1.133 2.176 1.497 3.568 1.111zm23.707-.29c1.067-.536 1.656-1.551 1.656-2.853 0-2.989-3.52-4.387-5.537-2.2-1.292 1.402-1.244 3.16.121 4.485 1.061 1.029 2.433 1.237 3.76.569z",
  fill: "none"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnavailable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unavailable.5a1a23b178629e186368f92f67f9f055.svg";